import { FleekError } from './FleekError';

type ObjectId = {
  id?: string;
};

type TemplateNotFoundErrorOptions = {
  template: ObjectId;
};

export class TemplateNotFoundError extends FleekError<TemplateNotFoundErrorOptions> {
  public name = 'TemplateNotFoundError';

  toString = () => `Template not found.`;
}
